module.exports = __webpack_public_path__ + "static/media/new_pack_dog_FR_768x350.85a5014d.png";